(function ($, Global) {
    var urlParams = new UrlParams();
	var lvlFontSize = 0;
	var ArticleToolsComponent = function (model) {
		this.model = model;
    };
    var timer = null;

	ArticleToolsComponent.prototype.initEvents = function () {
		this.publishers();
	}

	ArticleToolsComponent.prototype.publishers = function () {
		var self = this;

		$(document).ready(function () {
            handlePageReady.call(this);
        });

		$(document).on('click', '.btn-zoom-text', function () {
            handleBtnZoomClicked.call(this);
        });

		$(document).on('click', '.btn-read-later', function (e) {
            handleBtnReadLaterClicked.call(this, e, self.model);
        });
    }

    function handlePageReady() {
        var params = urlParams.getParams();
        var metaSocial = {
            title: $('[data-share-title]').data('share-title') || '',
            text: $('[data-share-text]').data('share-text') || '',
            image: $('[data-share-image]').data('share-image') || '',
            url: $('[data-share-url]').data('share-url') || '',
            class_prefix: 's_',
            width: 640,
            height: 480
        };

        $('.share').ShareLink(metaSocial);

        if (params['share']) {
            $('.tools').hide();
            setTimeout(function () {
                $('.tools').fadeIn('slow').addClass('shadow');
                $('.btn.share.s_' + params['share']).trigger('click');
            }, 300)
        }
    }

    function handleBtnZoomClicked() {
        lvlFontSize = lvlFontSize == 3 ? 0 : lvlFontSize + 1;

        var $elemTitle = $('.article-header .article-title').exists() ?
            $('.article-header .article-title') :
            null;
        var $elemBody = $('.article .article-body').exists() ?
            $('.article .article-body') :
            null;
        var $elemChapo = $('.article .article-chapo').exists() ? $('.article .article-chapo') : null;

        [$elemTitle, $elemBody, $elemChapo].forEach(function ($el) {
            zoomText($el, lvlFontSize);
        });
    }

    function handleBtnReadLaterClicked(event, model) {
        event.preventDefault();

        var $this = $(this);
        var data = $this.attr('data-article');
        var $tip = $this.closest('.tip');
        var $tipText = $tip.find('.tip-text');

        if ($this.attr('onclick') || $this.attr('data-toggle') === "modal" || $this.hasClass('check')) {
            $tip.addClass('in');
            clearTimeout(timer);
            timer = setTimeout(function () {
                $tip.removeClass('in');
            }, 8000)
        } else {
            var waitingTemplate = $('#waitingReadLaterProcess').html();
            $tipText.html(waitingTemplate);
            $tip.addClass('in');

            model.readLater(data, function (response) {
                $this.addClass('check');
                $tipText.html(response.data.message);
                clearTimeout(timer);
                timer = setTimeout(function () {
                    $tip.removeClass('in');
                }, 8000)
            });
        }
    }

    function zoomText($el, lvlFontSize) {
        if (!$el || !$el.exists()) return;

        var size = parseInt($el.css('font-size').replace('px', ''), 10);

        if (lvlFontSize === 0) {
            $el.css('font-size', '');
        } else {
            $el.css('font-size', (size + 3) + 'px');
        }
    }

	Global.ArticleToolsComponent = ArticleToolsComponent;
}(jQuery, window));